import { useTranslation } from 'react-i18next';

import type { Badges } from '@myphx-engineering/phx-design-system';

import {
    type PatientSavingsRecommendationInfoFragment,
    type PlanSavingsRecommendationInfoFragment,
    RecommendationKind,
} from '../graphql/generated/graphql';
import { formatToLocalizedCurrency } from '../util/formatting/currency';

export const useRecommendationBadge =
    () =>
    (
        recommendation:
            | PatientSavingsRecommendationInfoFragment
            | PlanSavingsRecommendationInfoFragment
    ): Badges | undefined => {
        const { t } = useTranslation();
        switch (recommendation.kind) {
            case RecommendationKind.AlternativePatientSavings:
                return {
                    label: t('alternatives.saveTag', {
                        amount: formatToLocalizedCurrency(
                            recommendation.savings
                        ),
                    }),
                    color: 'success' as const,
                };
            case RecommendationKind.AlternativePlanSavings:
                return {
                    label: t('alternatives.planSaveTag', {
                        amount: formatToLocalizedCurrency(
                            recommendation.savings
                        ),
                    }),
                    color: 'info' as const,
                };
            default:
                return undefined;
        }
    };
